<div class="content-wrapper">
    <div class="content-body bi-financeiro">

        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <!-- CABEÇALHO: empresa, período, comparação e atualização -->
        <div class="card bi-toolbar">
            <div class="card-body d-flex flex-wrap align-items-center justify-content-between">
                <div class="d-flex align-items-center mr-2 mb-1">
                    <div class="avatar bg-light-primary mr-1">
                        <span class="avatar-content font-weight-bolder">{{ nomeEmpresa.charAt(0) }}</span>
                    </div>
                    <div>
                        <h4 class="mb-0">{{ nomeEmpresa }}</h4>
                        <small class="text-muted" *ngIf="dados?.periodo">
                            Competências {{ rotuloCompetencia(dados.periodo.inicio) }} a {{ rotuloCompetencia(dados.periodo.fim) }}
                            <span *ngIf="comparar && dados.periodo_anterior">
                                · comparado com {{ rotuloCompetencia(dados.periodo_anterior.inicio) }} a
                                {{ rotuloCompetencia(dados.periodo_anterior.fim) }}</span>
                        </small>
                    </div>
                </div>

                <div class="d-flex flex-wrap align-items-center bi-filtros">
                    <select class="custom-select custom-select-sm mr-1 mb-1" [(ngModel)]="opcaoPeriodo"
                        (change)="trocarPeriodo()" [disabled]="carregando" aria-label="Período">
                        <option *ngFor="let o of opcoesPeriodo" [value]="o.valor">{{ o.nome }}</option>
                    </select>

                    <ng-container *ngIf="opcaoPeriodo === 'personalizado'">
                        <input type="month" class="form-control form-control-sm mr-50 mb-1 bi-mes" [(ngModel)]="inicioPersonalizado"
                            [min]="primeiraCompetencia" [max]="ultimaCompetencia" aria-label="Mês inicial" />
                        <span class="text-muted mr-50 mb-1">a</span>
                        <input type="month" class="form-control form-control-sm mr-50 mb-1 bi-mes" [(ngModel)]="fimPersonalizado"
                            [min]="primeiraCompetencia" [max]="ultimaCompetencia" aria-label="Mês final" />
                        <button class="btn btn-primary btn-sm mr-1 mb-1" (click)="aplicarPersonalizado()" [disabled]="carregando">
                            Aplicar
                        </button>
                    </ng-container>

                    <div class="custom-control custom-switch mr-1 mb-1">
                        <input type="checkbox" class="custom-control-input" id="biComparar" [(ngModel)]="comparar"
                            (change)="trocarComparacao()" />
                        <label class="custom-control-label" for="biComparar">Comparar com período anterior</label>
                    </div>

                    <button class="btn btn-outline-primary btn-sm mb-1" (click)="carregar()" [disabled]="carregando"
                        title="Consulta de novo os dados do banco (não consulta o Efí)">
                        <span *ngIf="carregando" class="spinner-border spinner-border-sm mr-25"></span>
                        <span *ngIf="!carregando"><i data-feather="refresh-cw" class="mr-25"></i></span>
                        Atualizar
                    </button>
                </div>
            </div>
            <div class="card-footer py-50 small text-muted" *ngIf="dados">
                <i data-feather="clock" class="mr-25"></i>
                Última atualização das vendas: {{ dataHora(dados.ultima_atualizacao_vendas) }}
                · último aviso do webhook: {{ dataHora(dados.ultimo_webhook) }}
                · consultado em {{ consultadoEm | date: 'dd/MM/yyyy HH:mm' }}
            </div>
        </div>

        <div class="alert alert-danger" *ngIf="erroPeriodo">
            <div class="alert-body">{{ erroPeriodo }}</div>
        </div>

        <!-- ERRO -->
        <div class="card" *ngIf="erro && !carregando">
            <div class="card-body text-center py-3">
                <div class="avatar avatar-xl bg-light-danger mb-1">
                    <span class="avatar-content"><i data-feather="alert-triangle" class="font-large-1"></i></span>
                </div>
                <h5>Não foi possível carregar o dashboard</h5>
                <p class="text-muted">{{ erro }}</p>
                <button class="btn btn-primary btn-sm" (click)="carregar()">Tentar de novo</button>
            </div>
        </div>

        <!-- CARREGANDO (primeira carga) -->
        <div class="card" *ngIf="carregando && !dados">
            <div class="card-body text-center py-3 text-muted">
                <div class="spinner-border text-primary mb-1" role="status"></div>
                <p class="mb-0">Carregando os dados financeiros da {{ nomeEmpresa }}...</p>
            </div>
        </div>

        <!-- SEM DADOS -->
        <div class="card" *ngIf="dados?.sem_dados && !erro">
            <div class="card-body text-center py-3">
                <div class="avatar avatar-xl bg-light-secondary mb-1">
                    <span class="avatar-content"><i data-feather="bar-chart-2" class="font-large-1"></i></span>
                </div>
                <h5>Sem cobranças da {{ nomeEmpresa }}</h5>
                <p class="text-muted mb-0">Nenhum fechamento tem cobrança emitida no Efí para esta empresa.</p>
            </div>
        </div>

        <ng-container *ngIf="dados && !dados.sem_dados && !erro">
            <div [class.bi-recarregando]="carregando">

                <!-- QUALIDADE DOS DADOS -->
                <div class="alert alert-warning" *ngIf="temQualidadeParcial">
                    <div class="alert-body small">
                        <strong>Dados parciais neste período.</strong>
                        <span *ngIf="dados.qualidade.sem_status.qtd">
                            {{ dados.qualidade.sem_status.qtd }} cobrança(s) ({{ moeda(dados.qualidade.sem_status.valor) }}) sem situação
                            confirmada no Efí ficam fora do recebido, da inadimplência e das taxas.
                        </span>
                        <span *ngIf="dados.qualidade.valor_estimado">
                            {{ dados.qualidade.valor_estimado }} cobrança(s) com valor pela soma dos itens da venda (o Efí não
                            registrou o total).
                        </span>
                        <span *ngIf="dados.qualidade.sem_valor">{{ dados.qualidade.sem_valor }} cobrança(s) sem valor registrado.</span>
                        <span *ngIf="dados.qualidade.duplicadas.length">
                            {{ dados.qualidade.duplicadas.length }} cobrança(s) "Novo" duplicadas (o cliente tem outra cobrança
                            do mesmo fechamento) foram desconsideradas.
                        </span>
                    </div>
                </div>

                <!-- 1. INDICADORES FINANCEIROS -->
                <div class="row match-height">
                    <!-- Total cobrado -->
                    <div class="col-xl-3 col-sm-6 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-start">
                                    <h6 class="text-muted font-weight-normal mb-50">
                                        Total cobrado
                                        <span class="bi-ajuda" [ngbTooltip]="definicoes.cobrado" container="body"><i data-feather="info"></i></span>
                                    </h6>
                                    <div class="avatar bg-light-primary">
                                        <span class="avatar-content"><i data-feather="file-text" class="font-medium-3"></i></span>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap align-items-center">
                                    <h3 class="font-weight-bolder mb-0 mr-50">{{ resumo.atual.cobrado | currency: 'BRL' }}</h3>
                                    <ng-container *ngIf="comparar">
                                        <ng-container *ngTemplateOutlet="chipTpl; context: { c: chip(resumo.variacao.cobrado_pct, 'pct', 'neutro') }"></ng-container>
                                    </ng-container>
                                </div>
                                <p class="small text-muted mb-0 mt-50">
                                    {{ resumo.atual.qtd }} cobrança(s)
                                    <span *ngIf="comparar"> · anterior {{ moeda(resumo.anterior.cobrado) }}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Total recebido -->
                    <div class="col-xl-3 col-sm-6 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-start">
                                    <h6 class="text-muted font-weight-normal mb-50">
                                        Total recebido
                                        <span class="bi-ajuda" [ngbTooltip]="definicoes.recebido" container="body"><i data-feather="info"></i></span>
                                    </h6>
                                    <div class="avatar bg-light-success">
                                        <span class="avatar-content"><i data-feather="check-circle" class="font-medium-3"></i></span>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap align-items-center">
                                    <h3 class="font-weight-bolder mb-0 mr-50">{{ resumo.atual.recebido | currency: 'BRL' }}</h3>
                                    <ng-container *ngIf="comparar">
                                        <ng-container *ngTemplateOutlet="chipTpl; context: { c: chip(resumo.variacao.recebido_pct, 'pct', 'alta_boa', 'warning') }"></ng-container>
                                    </ng-container>
                                </div>
                                <p class="small text-muted mb-0 mt-50">
                                    Taxa de recebimento {{ percentual(resumo.atual.taxa_recebimento) }}
                                    <span *ngIf="resumo.atual.em_confirmacao > 0"> · {{ moeda(resumo.atual.em_confirmacao) }} em confirmação</span>
                                    <span *ngIf="resumo.atual.a_vencer > 0" class="d-block">{{ moeda(resumo.atual.a_vencer) }} ainda a vencer</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Saldo em aberto -->
                    <div class="col-xl-3 col-sm-6 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-start">
                                    <h6 class="text-muted font-weight-normal mb-50">
                                        Saldo em aberto
                                        <span class="bi-ajuda" [ngbTooltip]="definicoes.saldo" container="body"><i data-feather="info"></i></span>
                                    </h6>
                                    <div class="avatar bg-light-info">
                                        <span class="avatar-content"><i data-feather="clock" class="font-medium-3"></i></span>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap align-items-center">
                                    <h3 class="font-weight-bolder mb-0 mr-50">{{ resumo.atual.saldo_aberto | currency: 'BRL' }}</h3>
                                    <ng-container *ngIf="comparar">
                                        <ng-container *ngTemplateOutlet="chipTpl; context: { c: chip(resumo.variacao.saldo_aberto_pct, 'pct', 'alta_ruim', 'warning') }"></ng-container>
                                    </ng-container>
                                </div>
                                <p class="small text-muted mb-0 mt-50">
                                    A vencer {{ moeda(resumo.atual.a_vencer) }} · vencido
                                    <span [class.text-danger]="resumo.atual.vencido > 0">{{ moeda(resumo.atual.vencido) }}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Inadimplência -->
                    <div class="col-xl-3 col-sm-6 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-start">
                                    <h6 class="text-muted font-weight-normal mb-50">
                                        Inadimplência
                                        <span class="bi-ajuda" [ngbTooltip]="definicoes.inadimplencia" container="body"><i data-feather="info"></i></span>
                                    </h6>
                                    <div class="avatar bg-light-danger">
                                        <span class="avatar-content"><i data-feather="alert-circle" class="font-medium-3"></i></span>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap align-items-center">
                                    <h3 class="font-weight-bolder mb-0 mr-50">{{ resumo.atual.vencido | currency: 'BRL' }}</h3>
                                    <ng-container *ngIf="comparar">
                                        <ng-container *ngTemplateOutlet="chipTpl; context: { c: chip(resumo.variacao.inadimplencia_pp, 'pp', 'alta_ruim') }"></ng-container>
                                    </ng-container>
                                </div>
                                <p class="small text-muted mb-0 mt-50">
                                    <span *ngIf="resumo.atual.inadimplencia_pct != null">{{ percentual(resumo.atual.inadimplencia_pct, 2) }} do valor já vencido</span>
                                    <span *ngIf="resumo.atual.inadimplencia_pct == null">Nada vencido com situação conhecida</span>
                                    <span *ngIf="comparar && resumo.anterior.inadimplencia_pct != null"> · anterior {{ percentual(resumo.anterior.inadimplencia_pct, 2) }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="small text-muted mt-n1 mb-2" *ngIf="comparar && !dados.comparacao.confiavel">
                    <i data-feather="alert-circle" class="mr-25"></i>
                    Comparação limitada: {{ dados.comparacao.motivos.join('; ') }}.
                </p>

                <!-- 2. GRÁFICOS PRINCIPAIS -->
                <div class="row">
                    <div class="col-xl-8 col-12">
                        <div class="bi-secao">
                            <h5 class="mb-0">Cobrado x recebido</h5>
                            <small class="text-muted">por competência<span *ngIf="comparar"> · tom claro: período anterior</span></small>
                        </div>
                        <div class="card">
                            <div class="card-body pb-0">
                                <app-bi-grafico [opcoes]="graficoCobradoRecebido"></app-bi-grafico>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-12">
                        <div class="bi-secao">
                            <h5 class="mb-0">Evolução da inadimplência</h5>
                            <small class="text-muted">situação atual de cada competência</small>
                        </div>
                        <div class="card">
                            <div class="card-body pb-0">
                                <app-bi-grafico [opcoes]="graficoInadimplencia"></app-bi-grafico>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-8 col-12">
                        <div class="bi-secao">
                            <h5 class="mb-0">Evolução dos recebimentos</h5>
                            <small class="text-muted">variação só entre meses já vencidos</small>
                        </div>
                        <div class="card">
                            <div class="card-body pb-0">
                                <app-bi-grafico [opcoes]="graficoRecebimentos"></app-bi-grafico>
                            </div>
                            <div class="card-footer py-50 small text-muted" *ngIf="temMesEmAndamento">
                                * competência com boletos ainda a vencer: o recebido vai crescer até o vencimento.
                            </div>
                        </div>
                    </div>

                    <!-- 3. INDICADORES DE DESEMPENHO -->
                    <div class="col-xl-4 col-12">
                        <div class="bi-secao">
                            <h5 class="mb-0">Indicadores de desempenho</h5>
                            <small class="text-muted">período atual</small>
                        </div>
                        <div class="card">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let i of desempenho">
                                    <div class="mr-1">
                                        <span class="d-block">{{ i.nome }}
                                            <span class="bi-ajuda" [ngbTooltip]="i.ajuda" container="body"><i data-feather="info"></i></span>
                                        </span>
                                        <small class="text-muted">{{ i.grupo }}<span *ngIf="i.extra"> · {{ i.extra }}</span><span
                                                *ngIf="comparar && i.anterior"> · anterior {{ i.anterior }}</span></small>
                                    </div>
                                    <span *ngIf="i.tipo === 'variacao' || i.tipo === 'pp'"
                                        class="badge badge-light-{{ chip(i.valor, i.tipo === 'pp' ? 'pp' : 'pct', i.sentido, 'warning').cor }} font-small-3">
                                        {{ valorIndicador(i) }}
                                    </span>
                                    <span *ngIf="i.tipo !== 'variacao' && i.tipo !== 'pp'" class="font-weight-bolder text-nowrap">{{ valorIndicador(i) }}</span>
                                </li>
                                <li class="list-group-item text-muted small" *ngIf="!desempenho.length">
                                    Nenhum indicador calculável com os dados do período.
                                </li>
                            </ul>
                            <div class="card-footer py-50 small text-muted" *ngIf="indicadoresOcultos.length">
                                Sem base no período: {{ indicadoresOcultos.join(', ') }}
                                <span *ngIf="dados.desempenho.tempo_recebimento.atual.amostra < dados.criterios.amostra_minima_pagamentos">
                                    (precisa de {{ dados.criterios.amostra_minima_pagamentos }} pagamentos com data registrada pelo webhook).
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 4. DIAGNÓSTICO GERENCIAL -->
                <div class="bi-secao">
                    <h5 class="mb-0">Diagnóstico gerencial</h5>
                    <small class="text-muted">critérios configurados na API</small>
                </div>
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-0" *ngIf="!dados.diagnosticos.length">
                            <i data-feather="check-circle" class="text-success mr-25"></i>
                            Nenhum alerta para o período com os critérios atuais.
                        </p>
                        <div *ngFor="let d of dados.diagnosticos; let ultimo = last" class="alert alert-{{ prioridades[d.prioridade].cor }}"
                            [class.mb-0]="ultimo">
                            <div class="alert-body">
                                <div class="d-flex justify-content-between flex-wrap mb-50">
                                    <strong>
                                        <span *ngIf="d.prioridade === 'critico'"><i data-feather="alert-octagon" class="mr-25"></i></span>
                                        <span *ngIf="d.prioridade === 'atencao'"><i data-feather="alert-triangle" class="mr-25"></i></span>
                                        <span *ngIf="d.prioridade === 'informativo'"><i data-feather="info" class="mr-25"></i></span>
                                        {{ d.titulo }}
                                    </strong>
                                    <span class="badge badge-{{ prioridades[d.prioridade].cor }}">{{ prioridades[d.prioridade].nome }}</span>
                                </div>
                                <p class="mb-50 font-weight-normal">{{ d.descricao }}</p>
                                <div class="row small bi-diagnostico">
                                    <div class="col-md-3 col-6 mb-50"><span class="d-block bi-rotulo">Indicador</span>{{ d.indicador }}</div>
                                    <div class="col-md-2 col-6 mb-50"><span class="d-block bi-rotulo">Valor atual</span>{{ formatar(d.valor_atual) }}</div>
                                    <div class="col-md-2 col-6 mb-50"><span class="d-block bi-rotulo">Variação</span>{{ formatar(d.variacao) }}</div>
                                    <div class="col-md-2 col-6 mb-50"><span class="d-block bi-rotulo">Impacto estimado</span>{{ d.impacto != null ? moeda(d.impacto) : '—' }}</div>
                                    <div class="col-md-3 col-12 mb-50"><span class="d-block bi-rotulo">Ação recomendada</span>{{ d.acao }}
                                        <span *ngIf="d.fechamentos?.length" class="d-block">
                                            <a *ngFor="let f of d.fechamentos" href="javascript:void(0)" class="mr-50 font-weight-bolder"
                                                (click)="abrirFechamento(f)">Fechamento {{ f }}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 5. FECHAMENTOS -->
                <div class="bi-secao">
                    <h5 class="mb-0">Fechamentos</h5>
                    <small class="text-muted">clique na linha para abrir Vendas e Boletos</small>
                </div>
                <div class="card">
                    <div class="card-body pb-0">
                        <div class="row">
                            <div class="col-md-5 mb-1">
                                <input type="search" class="form-control" placeholder="Pesquisar por fechamento, competência ou situação"
                                    [(ngModel)]="buscaFechamento" (keyup)="filtrarFechamentos()" (search)="filtrarFechamentos()" />
                            </div>
                            <div class="col-md-4 mb-1">
                                <select class="form-control" [(ngModel)]="filtroSituacao" (change)="filtrarFechamentos()" aria-label="Situação">
                                    <option value="">Todas as situações</option>
                                    <option *ngFor="let s of situacoes" [value]="s">{{ s }}</option>
                                </select>
                            </div>
                            <div class="col-md-3 mb-1 text-md-right">
                                <button class="btn btn-outline-primary" (click)="exportarCsv()" [disabled]="!fechamentos.length">
                                    <i data-feather="download" class="mr-25"></i> Exportar CSV
                                </button>
                            </div>
                        </div>
                    </div>
                    <ngx-datatable class="material core-bootstrap bi-tabela bi-clicavel" [rows]="fechamentos" [rowHeight]="'auto'" [limit]="10"
                        [columnMode]="ColumnMode.force" [headerHeight]="45" [footerHeight]="50" [scrollbarH]="true"
                        [sorts]="[{ prop: 'id_fechamento', dir: 'desc' }]" (activate)="ativarLinha($event)"
                        [messages]="{ emptyMessage: 'Nenhum fechamento com os filtros atuais.', totalMessage: 'fechamento(s)' }">
                        <ngx-datatable-column name="Data" prop="dt_fechamento" [width]="100">
                            <ng-template let-row="row" ngx-datatable-cell-template>{{ data(row.dt_fechamento) }}</ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Fechamento" prop="id_fechamento" [width]="120">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="font-weight-bolder">#{{ row.id_fechamento }}</span>
                                <small class="text-muted d-block">{{ row.rotulo }}</small>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Cobrado" prop="cobrado" [width]="120">
                            <ng-template let-value="value" ngx-datatable-cell-template>{{ value | currency: 'BRL' }}</ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Recebido" prop="recebido" [width]="120">
                            <ng-template let-value="value" ngx-datatable-cell-template>{{ value | currency: 'BRL' }}</ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Saldo em aberto" prop="saldo_aberto" [width]="120">
                            <ng-template let-value="value" ngx-datatable-cell-template>{{ value | currency: 'BRL' }}</ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Saldo vencido" prop="vencido" [width]="120">
                            <ng-template let-value="value" ngx-datatable-cell-template>
                                <span [class.text-danger]="value > 0">{{ value | currency: 'BRL' }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Cobranças" prop="qtd" [width]="90"></ngx-datatable-column>
                        <ngx-datatable-column name="Situação" prop="situacao" [width]="160">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="badge badge-pill badge-light-{{ row.cor }}">{{ row.situacao }}</span>
                                <small class="text-muted d-block" *ngIf="row.sem_status > 0">{{ moeda(row.sem_status) }} sem situação</small>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>

                <!-- 6. INADIMPLÊNCIA -->
                <div class="bi-secao">
                    <h5 class="mb-0">Análise de inadimplência</h5>
                    <small class="text-muted">cobranças vencidas e não pagas do período</small>
                </div>
                <div class="row match-height">
                    <div class="col-xl-4 col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="row text-center mb-1">
                                    <div class="col-4">
                                        <small class="text-muted d-block">Vencido</small>
                                        <span class="font-weight-bolder text-danger">{{ moeda(dados.inadimplencia.total_vencido) }}</span>
                                    </div>
                                    <div class="col-4">
                                        <small class="text-muted d-block">Clientes</small>
                                        <span class="font-weight-bolder">{{ dados.inadimplencia.clientes }}</span>
                                    </div>
                                    <div class="col-4">
                                        <small class="text-muted d-block">Cobranças</small>
                                        <span class="font-weight-bolder">{{ dados.inadimplencia.cobrancas }}</span>
                                    </div>
                                </div>
                                <h6 class="mb-1">Por faixa de atraso</h6>
                                <div *ngFor="let f of dados.inadimplencia.faixas" class="mb-75">
                                    <div class="d-flex justify-content-between small">
                                        <span>{{ f.faixa }}</span>
                                        <span><span class="font-weight-bolder">{{ moeda(f.valor) }}</span>
                                            <span class="text-muted"> · {{ f.qtd }}</span></span>
                                    </div>
                                    <div class="progress progress-bar-danger bi-progresso">
                                        <div class="progress-bar" role="progressbar" [style.width.%]="larguraFaixa(f)"></div>
                                    </div>
                                </div>
                                <p class="small text-muted mb-0" *ngIf="dados.inadimplencia.sem_data_vencimento.qtd">
                                    {{ dados.inadimplencia.sem_data_vencimento.qtd }} vencida(s) sem data de vencimento:
                                    {{ moeda(dados.inadimplencia.sem_data_vencimento.valor) }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-8 col-12">
                        <div class="card">
                            <div class="card-header pb-0">
                                <h6 class="card-title mb-0">Ranking de clientes por saldo vencido</h6>
                            </div>
                            <div class="card-body text-muted" *ngIf="!dados.inadimplencia.ranking.length">
                                <i data-feather="check-circle" class="text-success mr-25"></i>
                                Nenhuma cobrança vencida e não paga no período.
                            </div>
                            <ngx-datatable *ngIf="dados.inadimplencia.ranking.length" class="material core-bootstrap bi-tabela"
                                [rows]="dados.inadimplencia.ranking" [rowHeight]="'auto'" [limit]="8" [columnMode]="ColumnMode.force"
                                [headerHeight]="45" [footerHeight]="50" [scrollbarH]="true"
                                [messages]="{ emptyMessage: 'Nenhum cliente.', totalMessage: 'cliente(s)' }">
                                <ngx-datatable-column name="Cliente" prop="cliente" [width]="260">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        <span class="font-weight-bolder">{{ row.cliente }}</span>
                                        <small class="d-block">
                                            <a *ngFor="let f of row.fechamentos" href="javascript:void(0)" class="mr-50"
                                                (click)="abrirFechamento(f)">Fechamento {{ f }}</a>
                                        </small>
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Valor vencido" prop="valor" [width]="130">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        <span class="text-danger">{{ row.valor | currency: 'BRL' }}</span>
                                        <small class="text-muted d-block">{{ percentual(row.participacao_pct) }} do vencido</small>
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Dias de atraso" prop="dias_atraso" [width]="110">
                                    <ng-template let-value="value" ngx-datatable-cell-template>{{ value != null ? value : '—' }}</ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Cobranças vencidas" prop="qtd" [width]="110"></ngx-datatable-column>
                            </ngx-datatable>
                        </div>
                    </div>
                </div>

                <!-- 7. COMPORTAMENTO DE PAGAMENTO DOS CLIENTES -->
                <div class="bi-secao">
                    <h5 class="mb-0">Comportamento de pagamento dos clientes</h5>
                    <small class="text-muted">
                        competências {{ rotuloCompetencia(dados.pagadores.janela.inicio) }} a {{ rotuloCompetencia(dados.pagadores.janela.fim) }}
                        · cliente com pelo menos {{ dados.pagadores.minimo_cobrancas }} cobranças já vencidas
                    </small>
                </div>
                <div class="row match-height">
                    <div class="col-xl-4 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <h6 class="text-muted font-weight-normal mb-50">
                                    Índice de bons pagadores
                                    <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.bons_pagadores" container="body"><i data-feather="info"></i></span>
                                </h6>
                                <h3 class="font-weight-bolder mb-0">
                                    {{ dados.pagadores.indice_bons_pagadores_pct != null ? percentual(dados.pagadores.indice_bons_pagadores_pct) : '—' }}
                                </h3>
                                <p class="small text-muted mb-1">
                                    {{ qtdPagadores('bom') }} de {{ dados.pagadores.clientes_avaliados }} cliente(s) com histórico suficiente
                                    <span *ngIf="dados.pagadores.com_data_pagamento"> · {{ dados.pagadores.pontuais }} de
                                        {{ dados.pagadores.com_data_pagamento }} com data de pagamento pagaram em dia</span>
                                </p>
                                <div *ngFor="let r of dados.pagadores.resumo" class="mb-75">
                                    <div class="d-flex justify-content-between small">
                                        <span>{{ r.nome }}</span>
                                        <span><span class="font-weight-bolder">{{ r.clientes }}</span>
                                            <span class="text-muted"> · {{ moeda(r.cobrado) }}
                                                <span *ngIf="r.cobrado_pct != null">({{ percentual(r.cobrado_pct, 0) }} do cobrado)</span></span></span>
                                    </div>
                                    <div class="progress progress-bar-{{ corPagador[r.classe] }} bi-progresso">
                                        <div class="progress-bar" role="progressbar" [style.width.%]="r.clientes_pct || 0"></div>
                                    </div>
                                </div>
                                <p class="small text-muted mb-0" *ngIf="!dados.pagadores.clientes_avaliados">
                                    Nenhum cliente com situação de pagamento confirmada no Efí na janela: atualize a situação das
                                    cobranças em Vendas e Boletos para classificar os clientes.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-8 col-12">
                        <div class="card">
                            <div class="card-body pb-0">
                                <ul ngbNav class="nav-tabs mb-0" [activeId]="abaPagadores">
                                    <li *ngFor="let r of dados.pagadores.resumo" [ngbNavItem]="r.classe">
                                        <a ngbNavLink (click)="trocarAbaPagadores(r.classe)">{{ r.nome }} ({{ r.clientes }})</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-body text-muted small" *ngIf="!linhasPagadores.length">Nenhum cliente nesta classificação.</div>
                            <ngx-datatable *ngIf="linhasPagadores.length" class="material core-bootstrap bi-tabela" [rows]="linhasPagadores"
                                [rowHeight]="'auto'" [limit]="8" [columnMode]="ColumnMode.force" [headerHeight]="45" [footerHeight]="50"
                                [scrollbarH]="true" [messages]="{ emptyMessage: 'Nenhum cliente.', totalMessage: 'cliente(s)' }">
                                <ngx-datatable-column name="Cliente" prop="cliente" [width]="220">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        <span class="font-weight-bolder">{{ row.cliente }}</span>
                                        <span *ngIf="row.pontual === true" class="badge badge-pill badge-light-success ml-50">Em dia</span>
                                        <span *ngIf="row.pontual === false" class="badge badge-pill badge-light-warning ml-50">Pagou com atraso</span>
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Vencidas" prop="cobrancas_vencidas" [width]="70"></ngx-datatable-column>
                                <ngx-datatable-column name="Em aberto" prop="em_aberto" [width]="70">
                                    <ng-template let-value="value" ngx-datatable-cell-template>
                                        <span [class.text-danger]="value > 0">{{ value }}</span>
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Valor pago" prop="valor_pago" [width]="120">
                                    <ng-template let-value="value" ngx-datatable-cell-template><span class="text-nowrap">{{ value | currency: 'BRL' }}</span></ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Valor vencido" prop="valor_vencido" [width]="120">
                                    <ng-template let-value="value" ngx-datatable-cell-template>
                                        <span class="text-nowrap" [class.text-danger]="value > 0">{{ value | currency: 'BRL' }}</span>
                                    </ng-template>
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Adimpl." prop="indice_adimplencia_pct" [width]="80">
                                    <ng-template let-value="value" ngx-datatable-cell-template>{{ value != null ? percentual(value, 0) : '—' }}</ng-template>
                                </ngx-datatable-column>
                            </ngx-datatable>
                        </div>
                    </div>
                </div>

                <!-- 8. RETENÇÃO E CRESCIMENTO -->
                <div class="bi-secao">
                    <h5 class="mb-0">Retenção e crescimento</h5>
                    <small class="text-muted">cobrado por cliente: período atual x anterior</small>
                </div>
                <div class="alert alert-info" *ngIf="!dados.retencao.comparavel">
                    <div class="alert-body small">
                        Sem comparação entre os períodos: {{ dados.retencao.motivos.join('; ') }}.
                        Escolha um período cujo anterior também tenha cobranças em todos os meses.
                    </div>
                </div>
                <ng-container *ngIf="dados.retencao.comparavel">
                    <div class="row match-height">
                        <div class="col-xl col-md-4 col-6">
                            <div class="card bi-stat">
                                <div class="card-body">
                                    <h6 class="text-muted font-weight-normal mb-50">Retenção de clientes
                                        <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.retencao" container="body"><i data-feather="info"></i></span></h6>
                                    <h4 class="font-weight-bolder mb-0">{{ percentual(dados.retencao.retencao_clientes_pct) }}</h4>
                                    <small class="text-muted">{{ dados.retencao.retidos }} de {{ dados.retencao.clientes_anterior }} clientes</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl col-md-4 col-6">
                            <div class="card bi-stat">
                                <div class="card-body">
                                    <h6 class="text-muted font-weight-normal mb-50">Sem cobrança agora
                                        <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.perdidos" container="body"><i data-feather="info"></i></span></h6>
                                    <h4 class="font-weight-bolder mb-0" [class.text-danger]="dados.retencao.perdidos > 0">{{ dados.retencao.perdidos }}</h4>
                                    <small class="text-muted">{{ percentual(dados.retencao.churn_clientes_pct) }} da base ·
                                        {{ moeda(dados.retencao.receita.perdida) }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl col-md-4 col-6">
                            <div class="card bi-stat">
                                <div class="card-body">
                                    <h6 class="text-muted font-weight-normal mb-50">Clientes novos
                                        <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.novos" container="body"><i data-feather="info"></i></span></h6>
                                    <h4 class="font-weight-bolder mb-0 text-success">{{ dados.retencao.novos }}</h4>
                                    <small class="text-muted">{{ moeda(dados.retencao.receita.novos) }} faturados</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl col-md-6 col-6">
                            <div class="card bi-stat">
                                <div class="card-body">
                                    <h6 class="text-muted font-weight-normal mb-50">Receita líquida retida (NRR)
                                        <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.nrr" container="body"><i data-feather="info"></i></span></h6>
                                    <h4 class="font-weight-bolder mb-0" [class.text-success]="dados.retencao.nrr_pct >= 100"
                                        [class.text-warning]="dados.retencao.nrr_pct < 100">{{ percentual(dados.retencao.nrr_pct) }}</h4>
                                    <small class="text-muted">{{ dados.retencao.cresceram }} cliente(s) aumentaram</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl col-md-6 col-12">
                            <div class="card bi-stat">
                                <div class="card-body">
                                    <h6 class="text-muted font-weight-normal mb-50">Receita bruta retida (GRR)
                                        <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.grr" container="body"><i data-feather="info"></i></span></h6>
                                    <h4 class="font-weight-bolder mb-0">{{ percentual(dados.retencao.grr_pct) }}</h4>
                                    <small class="text-muted">{{ dados.retencao.reduziram }} reduziram · {{ dados.retencao.estaveis }} estáveis</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row match-height">
                        <div class="col-xl-5 col-12">
                            <div class="card">
                                <div class="card-header pb-0">
                                    <h6 class="card-title mb-0">Movimento do faturamento</h6>
                                </div>
                                <div class="card-body pt-1">
                                    <div *ngFor="let m of movimento; let ultimo = last" class="d-flex justify-content-between py-50"
                                        [class.border-top]="ultimo">
                                        <span [class.font-weight-bolder]="ultimo">{{ m.nome }}</span>
                                        <span class="text-nowrap {{ m.cor }}">{{ m.sinal }} {{ moeda(m.valor) }}</span>
                                    </div>
                                    <p class="small text-muted mb-0 mt-50">
                                        Crescimento ou redução: variação de pelo menos {{ dados.retencao.criterio_crescimento_pct }}% no cobrado do cliente.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-7 col-12">
                            <div class="card">
                                <div class="card-body pb-0">
                                    <ul ngbNav class="nav-tabs mb-0" [activeId]="abaRetencao">
                                        <li *ngFor="let a of abasRetencao" [ngbNavItem]="a.id">
                                            <a ngbNavLink (click)="trocarAbaRetencao(a.id)">{{ a.nome }} ({{ qtdRetencao(a.campo) }})</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="card-body text-muted small" *ngIf="!linhasRetencao.length">Nenhum cliente nesta lista.</div>
                                <ngx-datatable *ngIf="linhasRetencao.length" class="material core-bootstrap bi-tabela" [rows]="linhasRetencao"
                                    [rowHeight]="'auto'" [limit]="8" [columnMode]="ColumnMode.force" [headerHeight]="45" [footerHeight]="50"
                                    [scrollbarH]="true" [messages]="{ emptyMessage: 'Nenhum cliente.', totalMessage: 'cliente(s)' }">
                                    <ngx-datatable-column name="Cliente" prop="cliente" [width]="230">
                                        <ng-template let-value="value" ngx-datatable-cell-template><span class="font-weight-bolder">{{ value }}</span></ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="Anterior" prop="anterior" [width]="110">
                                        <ng-template let-value="value" ngx-datatable-cell-template><span class="text-nowrap">{{ value | currency: 'BRL' }}</span></ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="Atual" prop="atual" [width]="110">
                                        <ng-template let-value="value" ngx-datatable-cell-template><span class="text-nowrap">{{ value | currency: 'BRL' }}</span></ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="Variação" prop="variacao" [width]="110">
                                        <ng-template let-value="value" ngx-datatable-cell-template>
                                            <span class="text-nowrap" [class.text-success]="value > 0" [class.text-danger]="value < 0">{{ value | currency: 'BRL' }}</span>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="%" prop="variacao_pct" [width]="90">
                                        <ng-template let-value="value" ngx-datatable-cell-template><span class="text-nowrap">{{ value != null ? chip(value, 'pct', 'neutro').texto : '—' }}</span></ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- 9. PREVISÃO DE RECEBIMENTOS -->
                <div class="bi-secao">
                    <h5 class="mb-0">Previsão de recebimentos</h5>
                    <small class="text-muted">pelo vencimento dos boletos do período · não é saldo bancário nem caixa disponível</small>
                </div>
                <div class="row match-height">
                    <div class="col-lg-3 col-sm-6 col-12" *ngFor="let j of dados.previsao.janelas">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <h6 class="text-muted font-weight-normal mb-50">A vencer em até {{ j.dias }} dias</h6>
                                <h4 class="font-weight-bolder mb-0">{{ j.valor | currency: 'BRL' }}</h4>
                                <small class="text-muted">{{ j.qtd }} boleto(s) até {{ data(j.ate) }} · previsão</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-sm-6 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <h6 class="text-muted font-weight-normal mb-50">Situação atual do período</h6>
                                <div class="d-flex justify-content-between small"><span>Recebido</span>
                                    <span class="font-weight-bolder text-success">{{ moeda(dados.previsao.recebidas.valor) }}</span></div>
                                <div class="d-flex justify-content-between small" *ngIf="dados.previsao.em_confirmacao.qtd"><span>Em confirmação</span>
                                    <span class="font-weight-bolder">{{ moeda(dados.previsao.em_confirmacao.valor) }}</span></div>
                                <div class="d-flex justify-content-between small"><span>Vencido, não pago</span>
                                    <span class="font-weight-bolder text-danger">{{ moeda(dados.previsao.vencidas.valor) }}</span></div>
                                <div class="d-flex justify-content-between small"><span>A vencer após 30 dias</span>
                                    <span class="font-weight-bolder">{{ moeda(dados.previsao.apos_30_dias.valor) }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header pb-0">
                        <h6 class="card-title mb-0">Previsto x realizado</h6>
                    </div>
                    <div class="card-body pt-1">
                        <p class="small text-muted">Boletos do período que venceram nos últimos dias: quanto se previa receber
                            e quanto foi recebido até hoje.</p>
                        <div class="table-responsive">
                            <table class="table table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th>Vencimento</th>
                                        <th class="text-right">Previsto</th>
                                        <th class="text-right">Recebido</th>
                                        <th class="text-right">Em confirmação</th>
                                        <th class="text-right">Não pago</th>
                                        <th class="text-right">Realização</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let r of dados.previsao.realizacao">
                                        <td>Últimos {{ r.dias }} dias <small class="text-muted d-block">desde {{ data(r.de) }}</small></td>
                                        <td class="text-right">{{ moeda(r.previsto) }}</td>
                                        <td class="text-right text-success">{{ moeda(r.realizado) }}</td>
                                        <td class="text-right">{{ moeda(r.em_confirmacao) }}</td>
                                        <td class="text-right" [class.text-danger]="r.pendente > 0">{{ moeda(r.pendente) }}</td>
                                        <td class="text-right font-weight-bolder">
                                            {{ r.realizacao_pct != null ? percentual(r.realizacao_pct) : 'sem vencimentos' }}
                                            <small class="text-muted d-block" *ngIf="r.sem_status > 0">+ {{ moeda(r.sem_status) }} sem situação</small>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- 10. PREVISIBILIDADE -->
                <div class="bi-secao">
                    <h5 class="mb-0">Previsibilidade</h5>
                    <small class="text-muted">recorrência, concentração e estimativa da próxima competência</small>
                </div>
                <div class="row match-height">
                    <div class="col-xl-3 col-sm-6 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <h6 class="text-muted font-weight-normal mb-50">Receita recorrente
                                    <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.recorrente" container="body"><i data-feather="info"></i></span></h6>
                                <h4 class="font-weight-bolder mb-0">{{ dados.previsibilidade.receita_recorrente_pct != null ? percentual(dados.previsibilidade.receita_recorrente_pct) : '—' }}</h4>
                                <small class="text-muted" *ngIf="dados.previsibilidade.receita_recorrente_pct != null">
                                    {{ dados.previsibilidade.recorrentes }} de {{ dados.previsibilidade.clientes }} clientes cobrados em todos os meses</small>
                                <small class="text-muted" *ngIf="dados.previsibilidade.receita_recorrente_pct == null">precisa de 2 meses com cobranças no período</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-sm-6 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <h6 class="text-muted font-weight-normal mb-50">Concentração do faturamento
                                    <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.concentracao" container="body"><i data-feather="info"></i></span></h6>
                                <h4 class="font-weight-bolder mb-0">{{ percentual(dados.previsibilidade.concentracao_top10_pct) }}</h4>
                                <small class="text-muted">nos 10 maiores · 5 maiores: {{ percentual(dados.previsibilidade.concentracao_top5_pct) }}
                                    · HHI {{ dados.previsibilidade.indice_hhi != null ? (dados.previsibilidade.indice_hhi | number: '1.0-0') : '—' }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-sm-6 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <h6 class="text-muted font-weight-normal mb-50">Volatilidade mensal
                                    <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.volatilidade" container="body"><i data-feather="info"></i></span></h6>
                                <h4 class="font-weight-bolder mb-0">{{ dados.previsibilidade.volatilidade_pct != null ? percentual(dados.previsibilidade.volatilidade_pct) : '—' }}</h4>
                                <small class="text-muted">média de {{ moeda(dados.previsibilidade.cobrado_medio_mensal) }} por mês
                                    <span *ngIf="dados.previsibilidade.volatilidade_pct == null"> · precisa de 3 meses</span></small>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-sm-6 col-12">
                        <div class="card bi-stat">
                            <div class="card-body">
                                <h6 class="text-muted font-weight-normal mb-50">Faturamento médio por cliente</h6>
                                <h4 class="font-weight-bolder mb-0">{{ moeda(dados.previsibilidade.receita_media_por_cliente) }}</h4>
                                <small class="text-muted">por mês · {{ dados.previsibilidade.clientes }} cliente(s) no período</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body d-flex flex-wrap align-items-center justify-content-between">
                        <div class="mr-2 mb-50">
                            <h6 class="mb-25">
                                Estimativa para {{ rotuloCompetencia(dados.previsibilidade.projecao.competencia) }}
                                <span class="badge badge-light-secondary ml-50">estimativa</span>
                                <span class="bi-ajuda" [ngbTooltip]="definicoesClientes.projecao" container="body"><i data-feather="info"></i></span>
                            </h6>
                            <small class="text-muted" *ngIf="dados.previsibilidade.projecao.meses_base.length">
                                Base: {{ dados.previsibilidade.projecao.meses_base.map(rotuloCompetencia).join(', ') }}
                                <span *ngIf="dados.previsibilidade.projecao.meses_taxa.length">· taxa de recebimento de
                                    {{ dados.previsibilidade.projecao.meses_taxa.map(rotuloCompetencia).join(', ') }}</span>
                            </small>
                        </div>
                        <div class="d-flex flex-wrap">
                            <div class="mr-3 mb-50">
                                <small class="text-muted d-block">Cobrança esperada</small>
                                <span class="font-weight-bolder">{{ moeda(dados.previsibilidade.projecao.cobrado) }}</span>
                                <small class="text-muted d-block" *ngIf="dados.previsibilidade.projecao.minimo != null">
                                    entre {{ moeda(dados.previsibilidade.projecao.minimo) }} e {{ moeda(dados.previsibilidade.projecao.maximo) }}</small>
                            </div>
                            <div class="mb-50">
                                <small class="text-muted d-block">Recebimento esperado</small>
                                <span class="font-weight-bolder">{{ dados.previsibilidade.projecao.recebimento_esperado != null ? moeda(dados.previsibilidade.projecao.recebimento_esperado) : '—' }}</span>
                                <small class="text-muted d-block">
                                    {{ dados.previsibilidade.projecao.taxa_recebimento_pct != null
                                        ? percentual(dados.previsibilidade.projecao.taxa_recebimento_pct) + ' do vencido costuma ser pago'
                                        : 'sem meses fechados com situação confirmada' }}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <p class="small text-muted">
                    Período por competência (vigência do fechamento). O recebido é o que já foi pago das cobranças dessas
                    competências, não o que entrou no caixa no mês. Cobranças canceladas e de clientes de teste não entram.
                </p>
            </div>
        </ng-container>
    </div>
</div>

<!-- Chip de variação (padrão dos cards do Mantis) -->
<ng-template #chipTpl let-c="c">
    <span class="badge badge-light-{{ c.cor }} bi-chip">
        <span *ngIf="c.direcao > 0"><i data-feather="trending-up" class="mr-25"></i></span>
        <span *ngIf="c.direcao < 0"><i data-feather="trending-down" class="mr-25"></i></span>
        {{ c.texto }}
    </span>
</ng-template>
